export default "__VITE_ASSET__zNGSg0ys__"